import styled from '@emotion/styled';

// Container for the modal
export const Container = styled.div`
  padding: 1rem;
  width: 40rem;
  height: 20rem;
  position: relative;
  text-align: center;
`;

// Confirmation message
export const Message = styled.p`
  margin-bottom: 2rem;
  text-align: left;
`;
